import { render, staticRenderFns } from "./ExtraCreate.vue?vue&type=template&id=6ec50b01&"
import script from "./ExtraCreate.vue?vue&type=script&lang=js&"
export * from "./ExtraCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports